{
  "home": {
    "title": "Home",
    "branch": "Branch",
    "businessDate": "Business date",
    "employee": "Employee",
    "product": {
      "label": "Product",
      "DIESEL": "Diesel",
      "PETROL": "Petrol",
      "confirmSwitchTitle": "Switch to petrol?",
      "confirmSwitchDescription": "The next screens will work on petrol instead of diesel. You can switch back at any time.",
      "confirmSwitchConfirm": "Switch"
    },
    "purchase": "Purchase",
    "delivery": "Sale",
    "deliverySubtitle": "Hand over a sale receipt",
    "recent": "My recent operations",
    "frozen": "The system is temporarily frozen for a year operation",
    "noServices": "You do not have access to use this app",
    "noProducts": "You do not have access to any product",
    "inventoryMode": "Inventory count mode is on: purchases and sales are saved as pending until they are posted",
    "noShift": "No shift is currently open. Please wait until a new shift is opened before performing any transactions."
  },
  "header": {
    "menu": "Account menu"
  },
  "flow": {
    "back": "Back",
    "next": "Next",
    "stepHeader": "{{n}} of 3",
    "backHome": "Home",
    "loadError": "The data could not be loaded",
    "retry": "Refresh",
    "noAccess": "You do not have access to this screen",
    "optionRemoved": "A selected quantity option is no longer available and the count you entered for it was removed. Check the quantities.",
    "frozen": "The system is temporarily frozen for a year operation",
    "noProduct": "Choose the product on the home screen"
  },
  "purchase": {
    "title": "Purchase",
    "steps": {
      "quantity": "Quantity",
      "customer": "Customer",
      "review": "Review"
    },
    "quantity": {
      "barrels": "Number of barrels",
      "jerrycans": "Number of jerrycans",
      "deducted": "Number of deducted jerrycans",
      "increase": "Increase {{label}}",
      "decrease": "Decrease {{label}}",
      "barrelsGroup": "Barrels",
      "jerrycansGroup": "Jerrycans",
      "noOptions": "No quantity options are configured; contact the supervisor",
      "summaryTitle": "Net quantity",
      "summaryWords": "In words",
      "summaryJerrycans": "In jerrycans",
      "NO_CONTAINERS": "Enter the number of barrels or jerrycans",
      "NOT_POSITIVE": "The net quantity must be greater than zero",
      "DEDUCTED_TOO_MANY_DECIMALS": "At most five decimal places are allowed.",
      "DEDUCTED_TOO_LARGE": "Deducted jerrycans cannot exceed 100000."
    },
    "customer": {
      "phone": "Phone number",
      "search": "Search",
      "searching": "Searching...",
      "searchFirst": "Search by phone number to continue",
      "invalidPhone": "The phone number is not valid",
      "name": "Name",
      "vehiclePlate": "Vehicle number",
      "vehicleType": "Vehicle type",
      "optional": "optional",
      "vehicleNationality": "Vehicle nationality",
      "driverNationality": "Driver nationality",
      "knownNote": "To change the vehicle, contact the supervisor",
      "nationalityPlaceholder": "Select the nationality",
      "nationalitySearch": "Search nationalities...",
      "nationalitiesError": "The nationalities could not be loaded",
      "required": "Required fields are marked with an asterisk"
    },
    "review": {
      "product": "Product",
      "operation": "Operation type",
      "operationValue": "Purchase",
      "net": "Net quantity",
      "phone": "Phone number",
      "save": "Save",
      "saving": "Saving..."
    },
    "discard": {
      "title": "Discard changes?",
      "description": "The purchase data that was not saved will be lost.",
      "confirm": "Discard",
      "cancel": "Keep editing"
    }
  },
  "result": {
    "title": "Purchase saved",
    "reference": "Transaction number",
    "net": "Net quantity",
    "product": "Product",
    "qrLabel": "QR code of transaction {{reference}}",
    "print": "Print the receipt",
    "printing": "Printing...",
    "printed": "The receipt was sent to the printer",
    "whatsapp": "Send on WhatsApp",
    "sending": "Sending...",
    "whatsappStatus": "Message status",
    "retry": "Try again",
    "newOperation": "New operation",
    "loadError": "The receipt could not be loaded",
    "messageStatus": {
      "queued": "Queued",
      "sent": "Sent",
      "delivered": "Delivered",
      "read": "Read",
      "failed": "Failed",
      "invalid_phone": "Invalid phone"
    },
    "savedPending": "The transaction was saved as pending until it is posted",
    "titleSale": "Sale saved",
    "saleNote": "Give the receipt to the customer to complete the sale at the office"
  },
  "delivery": {
    "title": "Scan receipt",
    "opening": "Opening the camera...",
    "scan": "Scan the receipt",
    "scanAgain": "Scan another receipt",
    "manual": "Enter the number manually",
    "manualLabel": "Transaction number",
    "manualHint": "The number printed on the receipt",
    "lookup": "Search",
    "unknownCode": "Unknown code",
    "searching": "Looking up the transaction...",
    "details": {
      "reference": "Transaction number",
      "kind": "Transaction type",
      "product": "Product",
      "category": "Category",
      "qty": "Quantity",
      "lessJerrycans": "Less jerrycans",
      "net": "Net quantity",
      "status": "Delivery status",
      "debtor": "Customer name",
      "vehicle": "Vehicle number"
    },
    "kind": {
      "CASH_SALE": "Cash sale",
      "DEBT_SALE": "Debt sale",
      "PDA_SALE": "PDA sale"
    },
    "status": {
      "PENDING": "Pending delivery",
      "DELIVERED": "Delivered",
      "NOT_COMPLETED": "Awaiting completion"
    },
    "mismatch": "The receipt product ({{product}}) differs from the selected product",
    "switchTo": "Switch to {{product}}",
    "complete": "Complete the operation",
    "completing": "Delivering...",
    "confirmTitle": "Confirm delivery",
    "confirmDescription": "Confirm delivery of the full quantity for transaction {{reference}}?",
    "confirm": "Confirm",
    "notCompleted": "The sale is not completed yet. Send the customer to the office to complete it"
  },
  "recent": {
    "title": "My recent operations",
    "empty": "No operations today",
    "loadError": "The operations could not be loaded",
    "open": "Open receipt {{reference}}",
    "noName": "No name",
    "type": "Operation type"
  },
  "operation": {
    "PURCHASE": "Purchase",
    "SALE": "Sale"
  }
}
